<template>
  <div class="banner__layout">
    <div class="banner__banner banner_volunteers">
      <div class="banner__left">
        <h1>{{ $t("VOLUNTEERS.BANNER.TITLE") }}</h1>
        <p>{{ $t("VOLUNTEERS.BANNER.TEXT") }}</p>
        <div class="banner__bottom">
          <div
            class="banner__button button button_primary"
            @click="managePopupState({ popup: 'volunteersForm', _state: true })"
          >
            <span>{{ $t("VOLUNTEERS.BANNER.BUTTON_TEXT") }}</span>
          </div>
        </div>
      </div>
      <div class="banner__right">
        <img
          src="@/assets/images/QDLOp3qTiVzuezlhsT44y.svg"
          :alt="$t('ABOUT_TEXT')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "VolunteersBanner",
  methods: {
    ...mapMutations(["managePopupState"])
  }
};
</script>
